import { ReactElement, useEffect, useRef } from 'react';
import { tagHotJarRecording } from '@client/analytics/utils/analytics';
import { useElementVisibility } from '@client/common/hooks';
import { Props } from './';

export const AnalyticsTag = ({ tagName }: Props): ReactElement => {
  const { isElementVisible } = useElementVisibility();
  const tagRef = useRef<HTMLDivElement>(null);

  const isTagElementVisible = tagRef.current
    ? isElementVisible(tagRef.current)
    : false;

  useEffect(
    () => {
      if (isTagElementVisible) {
        tagHotJarRecording(tagName);
      }
    },
    [isTagElementVisible, tagName],
  );


  return <div ref={tagRef} />;
};
